import React, { Component } from 'react';
import { t } from '../../../../../locales';
import DashboardCardScenario from '../index';
import img from '../../../../../assets/images/vhis/dashboard/ico-over-18@3x.png';

interface ScenarioOverAgeProps {}

class ScenarioOverAge extends Component<ScenarioOverAgeProps> {
  render() {
    const props = {
      imageIcon: img,
      text: t('AXA_GOAL_SCENAVIO_OVER_AGE_TEXT'),
    };
    return <DashboardCardScenario {...props} />;
  }
}

export default ScenarioOverAge;
